import { EntityModal } from '../common/EntityModal';
import { ItemizedListView } from './ItemizedListView';
import type { ItemizedListFilters } from './ItemizedListView';

interface ItemizedListModalProps {
  open: boolean;
  onClose: () => void;
  eventId: string;
  /** Pre-selected filters (e.g. zoom-in from an expense row). */
  initialFilters?: ItemizedListFilters;
  title?: string;
}

/**
 * The event's itemized (inventory) list in a modal — opened from the vendors
 * section ("Itemized list") and from expense rows (zoom into linked items).
 */
export function ItemizedListModal({
  open,
  onClose,
  eventId,
  initialFilters,
  title = 'Itemized List',
}: ItemizedListModalProps) {
  if (!open) return null;
  return (
    <EntityModal open={open} onClose={onClose} title={title} size="xl">
      <ItemizedListView eventId={eventId} initialFilters={initialFilters} />
    </EntityModal>
  );
}
